import React from "react";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  CloseButton,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalDialog,
} from "@stadium/ui/src/components/ModalNew/utils";

import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";

import styles from "./main.module.scss";

const emptyObj = {};

const TemplateCategoriesModal = ({ data = emptyObj, closeModal }) => {
  const { renderCategoriesView, text = "Categories" } = data;

  return (
    <BottomIconHideWrapper>
      <Modal closeModal={closeModal} newModal mobileBottomDrawer>
        <ModalDialog>
          <ModalContent>
            <ModalHeader className={styles.modalHeader}>
              {text}
              <CloseButton
                onClick={() => closeModal()}
              />

            </ModalHeader>
            <ModalBody className={styles.modalBody}>
              {renderCategoriesView()}
            </ModalBody>
          </ModalContent>
        </ModalDialog>
      </Modal>
    </BottomIconHideWrapper>
  );
};

export default TemplateCategoriesModal;
